import { useQuery } from '@tanstack/vue-query'
import { computed, unref, type MaybeRef } from 'vue'

import { OlympusClient } from '@/OlympusClient'

import { QueryKey } from './QueryKey'

const STALE_TIME = 5 * 60 * 1000 // 5 minutes
const MAX_RETRIES = 2

/**
 * Fetches the IDs of locations with at least one past-due subscription for the
 * given brand.
 *
 * @param brandId - The brand ID to fetch past-due locations for
 */
export function usePastDueLocationsQuery(
  brandId: MaybeRef<string | undefined>
) {
  return useQuery({
    enabled: computed(() => !!unref(brandId)),
    queryFn: async ({ queryKey }) => {
      const [, , qBrandId] = queryKey

      if (!qBrandId) {
        throw new Error('Brand ID is required')
      }

      return await OlympusClient.billing.v2.brands.brand.subscriptions.getPastDueSubscriptions(
        {
          params: { brandId: qBrandId },
        }
      )
    },
    queryKey: [...QueryKey.PAST_DUE_LOCATIONS, brandId] as const,
    retry: MAX_RETRIES,
    staleTime: STALE_TIME,
  })
}
